var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsHomePinOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.125H6.875V6.40625H8.125V8.125H9.375V5.15625L7.5 3.90625L5.625 5.15625V8.125ZM7.5 12.0938C8.77083 10.9271 9.71354 9.86729 10.3281 8.91437C10.9427 7.96146 11.25 7.115 11.25 6.375C11.25 5.23958 10.8881 4.31 10.1644 3.58625C9.44063 2.8625 8.5525 2.50042 7.5 2.5C6.4475 2.49958 5.55958 2.86167 4.83625 3.58625C4.11292 4.31083 3.75083 5.24042 3.75 6.375C3.75 7.11458 4.05729 7.96104 4.67188 8.91437C5.28646 9.86771 6.22917 10.9275 7.5 12.0938ZM7.5 13.75C5.82292 12.3229 4.57042 10.9975 3.7425 9.77375C2.91458 8.55 2.50042 7.41708 2.5 6.375C2.5 4.8125 3.00271 3.56771 4.00813 2.64062C5.01354 1.71354 6.1775 1.25 7.5 1.25C8.8225 1.25 9.98667 1.71354 10.9925 2.64062C11.9983 3.56771 12.5008 4.8125 12.5 6.375C12.5 7.41667 12.086 8.54958 11.2581 9.77375C10.4302 10.9979 9.1775 12.3233 7.5 13.75Z",
    fill: "#970A02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsHomePinOutline);
export default __webpack_public_path__ + "static/media/material-symbols_home-pin-outline.9e9ab789fcf47624b2c8996ac02582a5.svg";
export { ForwardRef as ReactComponent };